"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapContext = void 0;
const Map_1 = __importDefault(require("ol/Map"));
const react_1 = require("react");
exports.MapContext = react_1.createContext({
    map: new Map_1.default({}),
    fullscreen: false,
});
//# sourceMappingURL=MapContext.js.map